"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_APPROVER_REPLACEMENT = void 0;
exports.UPDATE_APPROVER_REPLACEMENT = {
    USER_NOT_FOUND: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
            'EN-US': 'User not found.',
        },
    },
    APPROVER_REPLACEMENT_NOT_FOUND: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_REPLACEMENT_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Substituição do aprovador não encontrada.',
            'EN-US': 'Approver replacement not found.',
        },
    },
    UNAUTHORIZED_ACTOR: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'UNAUTHORIZED_ACTOR',
        messageLangMap: {
            'PT-BR': 'Usuário ator não tem permissão para atualizar a substituição de aprovação.',
            'EN-US': 'Actor user does not have permission to update approval replacement.',
        },
    },
    NON_UPDATABLE: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'NON_UPDATABLE',
        messageLangMap: {
            'PT-BR': 'A substituição do aprovador não pode ser atualizada.',
            'EN-US': 'The approver replacement cannot be updated.',
        },
    },
    APPROVER_REPLACEMENT_DATA_INVALID: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_REPLACEMENT_DATA_INVALID',
        messageLangMap: {
            'PT-BR': 'Dados da substituição do aprovador são inválidos.',
            'EN-US': 'Approver replacement data is invalid.',
        },
    },
    APPROVER_NOT_FOUND: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Aprovador não encontrado.',
            'EN-US': 'Approver not found.',
        },
    },
    REPLACER_NOT_FOUND: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'REPLACER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Substituto não encontrado.',
            'EN-US': 'Replacer not found.',
        },
    },
    INVALID_APPROVER_REPLACEMENT_UPDATE: {
        usecase: 'UPDATE_APPROVER_REPLACEMENT',
        type: 'INVALID_APPROVER_REPLACEMENT_UPDATE',
        messageLangMap: {
            'PT-BR': 'Substituição de aprovador inválida para atualização.',
            'EN-US': 'Invalid approver replacement for update.',
        },
    },
};
